import { RiAlertLine, RiCheckLine, RiInformationLine } from 'react-icons/ri';
import { useStore } from '../state/store';
import { cn } from '@/lib/utils';

const KIND_STYLE: Record<string, { icon: React.ComponentType<{ className?: string }>; ring: string }> = {
  info: { icon: RiInformationLine, ring: 'border-l-primary' },
  success: { icon: RiCheckLine, ring: 'border-l-[var(--color-evidence)]' },
  error: { icon: RiAlertLine, ring: 'border-l-[var(--color-cord)]' },
};

export function Toaster() {
  const toasts = useStore(state => state.toasts);
  const dismissToast = useStore(state => state.dismissToast);

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[340px] flex-col gap-2">
      {toasts.map(toast => {
        const style = KIND_STYLE[toast.kind] ?? KIND_STYLE.info;
        const Icon = style.icon;
        return (
          <button
            key={toast.id}
            type="button"
            onClick={() => dismissToast(toast.id)}
            className={cn(
              'pointer-events-auto flex items-start gap-2 rounded-[var(--radius)] border border-l-2 border-border bg-card px-3 py-2.5 text-left text-[11.5px] shadow-[0_12px_34px_rgba(27,28,30,0.16)]',
              style.ring
            )}
          >
            <Icon className="mt-px size-3.5 shrink-0 text-muted-foreground" />
            <span className="leading-relaxed">{toast.message}</span>
          </button>
        );
      })}
    </div>
  );
}